import React, { useEffect, useState } from 'react';
import qs from 'query-string';
import { Redirect, useHistory } from 'react-router-dom';

import { authService } from 'src/services/authService';

import Loader from '@uikit/old/Loader/Loader';
import { AuthHandlerType } from 'respona_api/generated/auth-shared_pb';
import { RealmType } from 'respona_api/generated/common_pb';

function BackdoorLoginPage({ location: { search } }: { location: Location }): JSX.Element {
  const history = useHistory();
  const { token } = qs.parse(search);
  const [error, changeError] = useState(null);

  useEffect(() => {
    if (token) {
      authService.loginWithToken(
        history,
        token as string,
        AuthHandlerType.ADMIN_AREA,
        RealmType.RESPONA_ADMIN
      );
    }
  }, [token]);

  if (!token) {
    return <Redirect to="/welcome" />;
  }

  if (error) {
    return <h2 style={{ textAlign: 'center' }}>{error}</h2>;
  }

  return <Loader isLoading withTopMargin />;
}

export default BackdoorLoginPage;
